import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { useDrawersContext } from "../../tasks/drawers-context";
import { AtiraToast } from "../../../utils/AtiraToast";
import { AssignEntryDto } from "../../../model/entry/dto/AssignEntryDto";
import { entryActions } from "../../../redux/entry/entry.slice";
import { EntityAssignModal } from "../../../components/EntityAssignModal";

export const EntryAssignModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { entry, entryAssignVisible, setEntryAssignVisible } =
    useDrawersContext();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const onAssign = async (ids: string[]) => {
    try {
      if (!entry) {
        return;
      }

      const updateDto: AssignEntryDto = {
        assigneeIds: ids,
        entryId: entry._id!,
        userId,
      };

      await dispatch(entryActions.assignEntry(updateDto)).unwrap();
      await dispatch(
        entryActions.getEntryById({
          userId,
          entryId: entry._id!,
        }),
      ).unwrap();

      AtiraToast.success(t("entries.table.assign-modal.success"));
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    }
  };

  return (
    <EntityAssignModal
      isOpen={entryAssignVisible}
      onClose={() => setEntryAssignVisible(false)}
      onConfirm={onAssign}
      entity={entry}
    />
  );
};
